// Function to remove an item from an array by ID
export const removeItemById = (data, id) => {

  return data.filter((s) => s.id !== id);
};

// Function to remove an item from an array by index
export const removeItemAtIndex = (data, index) => {
  let AttributesArray = data;
  AttributesArray.splice(index, 1);
  return AttributesArray;
};

// Function to update a list with a new value
export const updateList = (data, newValue) => {
  const newData = [...data];
  const index = newData.findIndex((n) => n.id === newValue.id);
  if (index > -1) {
    newData[index] = newValue;
  } else {
    newData.unshift(newValue);
  }
  return newData;
};


